export default __webpack_public_path__ + "static/media/Balthus's Woodsman Brassards.9b60e1ac.jpg";